import { useEffect, useState } from 'react';

import { canUseDom } from '@pkg/utils';

// NOTE: We might find that calling the following is quicker:
// `!window || !window.matchMedia`
const hasMatchMedia = canUseDom();

function getInitialState(query: string) {
    return hasMatchMedia ? window.matchMedia(query).matches : false;
}

export function useMedia(query: string) {
    const [match, setMatch] = useState(getInitialState(query));

    useEffect(() => {
        if (!hasMatchMedia) {
            return;
        }

        const matchMedia = window.matchMedia(query);
        const handleChange = (event: MediaQueryListEvent) => setMatch(event.matches);

        setMatch(matchMedia.matches);
        matchMedia.addEventListener('change', handleChange);

        return () => matchMedia.removeEventListener('change', handleChange);
    }, [query]);

    return match;
}
